export default {
  saturn: 'Saturn return',
  secondSaturn: 'Second Saturn return',
  uranus: 'Uranus opposition',
  chiron: 'Chiron return',
  solar: 'Solar return',
  lunar: 'Lunar return',
}
